
export default {
  'zh-CN': {
    edit: '编辑',
    save: '保存',
    purchaseDesc: '采购需求描述',
    noData: '暂无更多信息',
    saveSucceed: '保存成功',
    remark: '品类说明'
  },
  'en': {
    edit: 'Edit',
    save: 'Save',
    purchaseDesc: 'Purchase demand description',
    noData: 'No more information',
    saveSucceed: 'Saving succeeded',
    remark: 'Category Description'
  },
  'ja': {
    edit: '编辑',
    save: '保存',
    purchaseDesc: '采购需求描述',
    noData: '暂无更多信息',
    saveSucceed: '保存成功',
    remark: '品类说明'
  }
}
